<div id="footer">
  <div class="links">
    <div class="logoStore">
      <a [routerLink]="['/home']">
        <img
          src="./assets/images/logo/kinomap_primary_white.png"
          width="315"
          alt="kinomap logo white" />
      </a>

      <div class="appLink">
        <a
          href="https://apps.apple.com/fr/app/kinomap/id611177969"
          target="_blank"
          aria-label="Download Kinomap on the App Store"
          ><img
            src="./assets/images/store/apple_trans.svg"
            alt="Download Kinomap image on the App Store"
        /></a>
        <a
          href="https://play.google.com/store/apps/details?id=com.kinomap.training&hl=fr&gl=US"
          target="_blank"
          aria-label="Download Kinomap on Google Play"
          ><img
            src="./assets/images/store/google_trans.svg"
            alt="Download Kinomap image on Google Play"
        /></a>
      </div>

      @if (windowSize <= 768) {
        <div class="social">
          <div>
            <h5>{{ 'menu.followus' | translate }}</h5>
            <div class="socialLinks">
              <a
                href="https://www.facebook.com/kinomap"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow Kinomap on Facebook">
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M18 3C9.7155 3 3 9.7155 3 18C3 25.4865 8.4855 31.692 15.657 32.8185V22.335H11.847V18H15.657V14.6955C15.657 10.9365 17.895 8.8605 21.3225 8.8605C22.9635 8.8605 24.6795 9.153 24.6795 9.153V12.843H22.7895C20.925 12.843 20.3445 13.9995 20.3445 15.186V18H24.504L23.8395 22.335H20.3445V32.8185C27.5145 31.6935 33 25.485 33 18C33 9.7155 26.2845 3 18 3Z"
                    fill="white" />
                </svg>
              </a>
              <a
                href="https://www.twitter.com/kinomap"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow Kinomap on X">
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M18 3C26.2843 3 33 9.71573 33 18C33 26.2843 26.2843 33 18 33C9.71573 33 3 26.2843 3 18C3 9.71573 9.71573 3 18 3ZM8.83301 9.66699L15.4229 18.7686L9.18359 26.333H11.8652L16.7061 20.5029L20.9336 26.333H26.333L19.4521 16.7393L25.3418 9.66699H22.6592L18.1865 14.9922L14.3672 9.66699H8.83301ZM13.5859 11.2656L23.208 24.6729H21.7207L11.9883 11.2656H13.5859Z"
                    fill="white" />
                </svg>
              </a>
              <a
                href="https://instagram.com/kinomap"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow Kinomap on Instagram">
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M18 33C26.2843 33 33 26.2843 33 18C33 9.71573 26.2843 3 18 3C9.71573 3 3 9.71573 3 18C3 26.2843 9.71573 33 18 33ZM15.8787 15.8787C16.4413 15.3161 17.2044 15 18 15C18.7956 15 19.5587 15.3161 20.1213 15.8787C20.6839 16.4413 21 17.2044 21 18C21 18.7956 20.6839 19.5587 20.1213 20.1213C19.5587 20.6839 18.7956 21 18 21C17.2044 21 16.4413 20.6839 15.8787 20.1213C15.3161 19.5587 15 18.7956 15 18C15 17.2044 15.3161 16.4413 15.8787 15.8787ZM21.5355 14.4645C20.5979 13.5268 19.3261 13 18 13C16.6739 13 15.4021 13.5268 14.4645 14.4645C13.5268 15.4021 13 16.6739 13 18C13 19.3261 13.5268 20.5979 14.4645 21.5355C15.4021 22.4732 16.6739 23 18 23C19.3261 23 20.5979 22.4732 21.5355 21.5355C22.4732 20.5979 23 19.3261 23 18C23 16.6739 22.4732 15.4021 21.5355 14.4645ZM24.1339 13.6339C24.3683 13.3995 24.5 13.0815 24.5 12.75C24.5 12.4185 24.3683 12.1005 24.1339 11.8661C23.8995 11.6317 23.5815 11.5 23.25 11.5C22.9185 11.5 22.6005 11.6317 22.3661 11.8661C22.1317 12.1005 22 12.4185 22 12.75C22 13.0815 22.1317 13.3995 22.3661 13.6339C22.6005 13.8683 22.9185 14 23.25 14C23.5815 14 23.8995 13.8683 24.1339 13.6339ZM13.971 10.058C15.122 10.007 15.526 10 18 10C20.539 10 20.925 10.006 22.029 10.058C22.811 10.094 23.337 10.199 23.827 10.389C24.2355 10.5392 24.6047 10.7798 24.907 11.093C25.2191 11.396 25.4593 11.765 25.61 12.173C25.8 12.661 25.905 13.189 25.942 13.971C25.993 15.122 26 15.526 26 18C26 20.539 25.994 20.925 25.942 22.029C25.906 22.809 25.8 23.336 25.61 23.829C25.444 24.259 25.243 24.572 24.906 24.909C24.574 25.241 24.259 25.442 23.826 25.611C23.338 25.8 22.811 25.905 22.029 25.942C20.878 25.993 20.474 26 18 26C15.461 26 15.075 25.994 13.971 25.942C13.191 25.906 12.665 25.8 12.171 25.609C11.741 25.443 11.428 25.242 11.091 24.906C10.759 24.574 10.559 24.261 10.389 23.826C10.2 23.339 10.095 22.812 10.058 22.029C10.007 20.878 10 20.474 10 18C10 15.461 10.006 15.075 10.058 13.971C10.094 13.188 10.199 12.663 10.389 12.173C10.5394 11.7646 10.78 11.3954 11.093 11.093C11.426 10.759 11.739 10.558 12.173 10.39C12.661 10.2 13.187 10.095 13.971 10.058ZM22.122 8.06C21.056 8.01 20.717 8 18 8C15.283 8 14.944 8.013 13.878 8.06C12.812 8.11 12.088 8.277 11.45 8.525C10.7824 8.77573 10.1777 9.16923 9.678 9.678C9.1688 10.1773 8.77524 10.7822 8.525 11.45C8.277 12.088 8.11 12.812 8.06 13.878C8.01 14.944 8 15.283 8 18C8 20.717 8.013 21.056 8.06 22.122C8.11 23.187 8.277 23.913 8.525 24.55C8.77593 25.2175 9.16941 25.8222 9.678 26.322C10.1775 26.8309 10.7823 27.2245 11.45 27.475C12.088 27.722 12.813 27.89 13.878 27.94C14.944 27.99 15.283 28 18 28C20.717 28 21.056 27.987 22.122 27.94C23.187 27.89 23.913 27.722 24.55 27.475C25.2173 27.2238 25.822 26.8303 26.322 26.322C26.8311 25.8226 27.2247 25.2178 27.475 24.55C27.722 23.912 27.89 23.187 27.94 22.122C27.99 21.056 28 20.717 28 18C28 15.283 27.987 14.944 27.94 13.878C27.89 12.813 27.722 12.087 27.475 11.45C27.224 10.7826 26.8305 10.1779 26.322 9.678C25.766 9.123 25.21 8.779 24.55 8.525C23.912 8.277 23.187 8.11 22.122 8.06Z"
                    fill="white" />
                </svg>
              </a>
              <a
                href="https://www.youtube.com/user/Kinomap"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow Kinomap on YouTube">
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M18 33C26.2843 33 33 26.2843 33 18C33 9.71573 26.2843 3 18 3C9.71573 3 3 9.71573 3 18C3 26.2843 9.71573 33 18 33ZM28 18C28 18 28 14.28 27.543 12.498C27.292 11.516 26.55 10.742 25.605 10.476C23.896 10 18 10 18 10C18 10 12.107 10 10.395 10.476C9.454 10.738 8.711 11.513 8.457 12.498C8 14.28 8 18 8 18C8 18 8 21.72 8.457 23.502C8.708 24.484 9.45 25.258 10.395 25.524C12.107 26 18 26 18 26C18 26 23.896 26 25.605 25.524C26.546 25.262 27.289 24.487 27.543 23.502C28 21.72 28 18 28 18ZM22 18L16 21.5V14.5L22 18Z"
                    fill="white" />
                </svg>
              </a>
              <a
                href="https://www.strava.com/clubs/119385"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow Kinomap on Strava">
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M33 18C33 26.2843 26.2843 33 18 33C9.71573 33 3 26.2843 3 18C3 9.71573 9.71573 3 18 3C26.2843 3 33 9.71573 33 18ZM19.1551 19.2727L22.5709 19.2727L20.8061 22.7783L19.0655 19.2727H16.4545L20.8303 28L25.1818 19.2727L22.6364 19.2727L16.8021 8L11 19.2727H14.4812L16.8343 14.7446L19.1551 19.2727Z"
                    fill="white" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      }
    </div>

    <div class="linkBox">
      <div class="link">
        <h5 translate>menu.theapplication</h5>
        <a
          aria-label="navigate to motion"
          [routerLink]="['/browse']"
          fragment="motion"
          >{{ 'menu.motion' | translate }}</a
        >
        <a
          aria-label="navigate to coaching"
          [routerLink]="['/browse']"
          fragment="coaching"
          >{{ 'menu.coaching' | translate }}</a
        >
        <a
          aria-label="navigate to workout"
          [routerLink]="['/browse']"
          fragment="workout"
          >{{ 'menu.workout' | translate }}</a
        >
        <a
          aria-label="navigate to pricing"
          [routerLink]="['/home']"
          fragment="pricing"
          >{{ 'menu.pricing' | translate }}</a
        >
        <a aria-label="navigate to about" [routerLink]="['/about']">{{
          'menu.footer.about' | translate
        }}</a>
      </div>
      <div class="link">
        <h5 translate>menu.ourservices</h5>
        <h5 class="reward">
          <kin-icon name="star" color="#ffc947" />
          <a [href]="rewardLink" aria-label="navigate to reward">{{
            'reward.title' | translate
          }}</a>
        </h5>
        <a
          [routerLink]="['/dashboard/subscriptions/buy-voucher']"
          aria-label="navigate to gift cards"
          >{{ 'menu.footer.giftCards' | translate }}</a
        >
        <a [routerLink]="['media-kit']" aria-label="navigate to media kit">{{
          'mediakit.title' | translate
        }}</a>
        <a
          href="https://corporatewellness.kinomap.com/"
          aria-label="navigate to corporate wellness"
          >{{ 'menu.footer.corpowellness' | translate }}</a
        >
        <a href="https://store.kinomap.com/" aria-label="navigate to shop">{{
          'menu.footer.shop' | translate
        }}</a>
        <a
          href="https://creator.kinomap.com/workout"
          aria-label="navigate to creator"
          >{{ 'menu.footer.creator' | translate }}</a
        >
      </div>
      <div class="link">
        <h5 translate>menu.readmore</h5>
        <a
          aria-label="Navigate to get started"
          [routerLink]="['/get-started']"
          >{{ 'menu.getStarted' | translate }}</a
        >
        <a
          aria-label="Navigate to equipment"
          [routerLink]="['/compatibility']"
          >{{ 'menu.equipment' | translate }}</a
        >
        <a aria-label="Navigate to support" [href]="supportSafeLink">{{
          'menu.footer.support' | translate
        }}</a>
        <a aria-label="Navigate to sales" href="mailto:sales@kinomap.com">{{
          'menu.footer.sales' | translate
        }}</a>
        <!-- <a aria-label="Navigate to jobs"
        href="https://support.kinomap.com/hc/fr/categories/360005988152-OFFRES-D-EMPLOI">{{ 'menu.footer.jobs' |
        translate }}</a> -->
        <!-- <a
          aria-label="Navigate to race director"
          href="https://info.kinomap.com/race-director"
          >{{ 'menu.footer.race' | translate }}</a
        > -->
      </div>
    </div>
  </div>

  @if (windowSize > 768) {
    <div class="social">
      <div>
        <h5>{{ 'menu.followus' | translate }}</h5>
        <div class="socialLinks">
          <a
            href="https://www.facebook.com/kinomap"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Follow Kinomap on Facebook">
            <svg
              width="36"
              height="36"
              viewBox="0 0 36 36"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M18 3C9.7155 3 3 9.7155 3 18C3 25.4865 8.4855 31.692 15.657 32.8185V22.335H11.847V18H15.657V14.6955C15.657 10.9365 17.895 8.8605 21.3225 8.8605C22.9635 8.8605 24.6795 9.153 24.6795 9.153V12.843H22.7895C20.925 12.843 20.3445 13.9995 20.3445 15.186V18H24.504L23.8395 22.335H20.3445V32.8185C27.5145 31.6935 33 25.485 33 18C33 9.7155 26.2845 3 18 3Z"
                fill="white" />
            </svg>
          </a>
          <a
            href="https://www.twitter.com/kinomap"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Follow Kinomap on X">
            <svg
              width="36"
              height="36"
              viewBox="0 0 36 36"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M18 3C26.2843 3 33 9.71573 33 18C33 26.2843 26.2843 33 18 33C9.71573 33 3 26.2843 3 18C3 9.71573 9.71573 3 18 3ZM8.83301 9.66699L15.4229 18.7686L9.18359 26.333H11.8652L16.7061 20.5029L20.9336 26.333H26.333L19.4521 16.7393L25.3418 9.66699H22.6592L18.1865 14.9922L14.3672 9.66699H8.83301ZM13.5859 11.2656L23.208 24.6729H21.7207L11.9883 11.2656H13.5859Z"
                fill="white" />
            </svg>
          </a>
          <a
            href="https://instagram.com/kinomap"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Follow Kinomap on Instagram">
            <svg
              width="36"
              height="36"
              viewBox="0 0 36 36"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M18 33C26.2843 33 33 26.2843 33 18C33 9.71573 26.2843 3 18 3C9.71573 3 3 9.71573 3 18C3 26.2843 9.71573 33 18 33ZM15.8787 15.8787C16.4413 15.3161 17.2044 15 18 15C18.7956 15 19.5587 15.3161 20.1213 15.8787C20.6839 16.4413 21 17.2044 21 18C21 18.7956 20.6839 19.5587 20.1213 20.1213C19.5587 20.6839 18.7956 21 18 21C17.2044 21 16.4413 20.6839 15.8787 20.1213C15.3161 19.5587 15 18.7956 15 18C15 17.2044 15.3161 16.4413 15.8787 15.8787ZM21.5355 14.4645C20.5979 13.5268 19.3261 13 18 13C16.6739 13 15.4021 13.5268 14.4645 14.4645C13.5268 15.4021 13 16.6739 13 18C13 19.3261 13.5268 20.5979 14.4645 21.5355C15.4021 22.4732 16.6739 23 18 23C19.3261 23 20.5979 22.4732 21.5355 21.5355C22.4732 20.5979 23 19.3261 23 18C23 16.6739 22.4732 15.4021 21.5355 14.4645ZM24.1339 13.6339C24.3683 13.3995 24.5 13.0815 24.5 12.75C24.5 12.4185 24.3683 12.1005 24.1339 11.8661C23.8995 11.6317 23.5815 11.5 23.25 11.5C22.9185 11.5 22.6005 11.6317 22.3661 11.8661C22.1317 12.1005 22 12.4185 22 12.75C22 13.0815 22.1317 13.3995 22.3661 13.6339C22.6005 13.8683 22.9185 14 23.25 14C23.5815 14 23.8995 13.8683 24.1339 13.6339ZM13.971 10.058C15.122 10.007 15.526 10 18 10C20.539 10 20.925 10.006 22.029 10.058C22.811 10.094 23.337 10.199 23.827 10.389C24.2355 10.5392 24.6047 10.7798 24.907 11.093C25.2191 11.396 25.4593 11.765 25.61 12.173C25.8 12.661 25.905 13.189 25.942 13.971C25.993 15.122 26 15.526 26 18C26 20.539 25.994 20.925 25.942 22.029C25.906 22.809 25.8 23.336 25.61 23.829C25.444 24.259 25.243 24.572 24.906 24.909C24.574 25.241 24.259 25.442 23.826 25.611C23.338 25.8 22.811 25.905 22.029 25.942C20.878 25.993 20.474 26 18 26C15.461 26 15.075 25.994 13.971 25.942C13.191 25.906 12.665 25.8 12.171 25.609C11.741 25.443 11.428 25.242 11.091 24.906C10.759 24.574 10.559 24.261 10.389 23.826C10.2 23.339 10.095 22.812 10.058 22.029C10.007 20.878 10 20.474 10 18C10 15.461 10.006 15.075 10.058 13.971C10.094 13.188 10.199 12.663 10.389 12.173C10.5394 11.7646 10.78 11.3954 11.093 11.093C11.426 10.759 11.739 10.558 12.173 10.39C12.661 10.2 13.187 10.095 13.971 10.058ZM22.122 8.06C21.056 8.01 20.717 8 18 8C15.283 8 14.944 8.013 13.878 8.06C12.812 8.11 12.088 8.277 11.45 8.525C10.7824 8.77573 10.1777 9.16923 9.678 9.678C9.1688 10.1773 8.77524 10.7822 8.525 11.45C8.277 12.088 8.11 12.812 8.06 13.878C8.01 14.944 8 15.283 8 18C8 20.717 8.013 21.056 8.06 22.122C8.11 23.187 8.277 23.913 8.525 24.55C8.77593 25.2175 9.16941 25.8222 9.678 26.322C10.1775 26.8309 10.7823 27.2245 11.45 27.475C12.088 27.722 12.813 27.89 13.878 27.94C14.944 27.99 15.283 28 18 28C20.717 28 21.056 27.987 22.122 27.94C23.187 27.89 23.913 27.722 24.55 27.475C25.2173 27.2238 25.822 26.8303 26.322 26.322C26.8311 25.8226 27.2247 25.2178 27.475 24.55C27.722 23.912 27.89 23.187 27.94 22.122C27.99 21.056 28 20.717 28 18C28 15.283 27.987 14.944 27.94 13.878C27.89 12.813 27.722 12.087 27.475 11.45C27.224 10.7826 26.8305 10.1779 26.322 9.678C25.766 9.123 25.21 8.779 24.55 8.525C23.912 8.277 23.187 8.11 22.122 8.06Z"
                fill="white" />
            </svg>
          </a>
          <a
            href="https://www.youtube.com/user/Kinomap"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Follow Kinomap on YouTube">
            <svg
              width="36"
              height="36"
              viewBox="0 0 36 36"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M18 33C26.2843 33 33 26.2843 33 18C33 9.71573 26.2843 3 18 3C9.71573 3 3 9.71573 3 18C3 26.2843 9.71573 33 18 33ZM28 18C28 18 28 14.28 27.543 12.498C27.292 11.516 26.55 10.742 25.605 10.476C23.896 10 18 10 18 10C18 10 12.107 10 10.395 10.476C9.454 10.738 8.711 11.513 8.457 12.498C8 14.28 8 18 8 18C8 18 8 21.72 8.457 23.502C8.708 24.484 9.45 25.258 10.395 25.524C12.107 26 18 26 18 26C18 26 23.896 26 25.605 25.524C26.546 25.262 27.289 24.487 27.543 23.502C28 21.72 28 18 28 18ZM22 18L16 21.5V14.5L22 18Z"
                fill="white" />
            </svg>
          </a>
          <a
            href="https://www.strava.com/clubs/119385"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Follow Kinomap on Strava">
            <svg
              width="36"
              height="36"
              viewBox="0 0 36 36"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M33 18C33 26.2843 26.2843 33 18 33C9.71573 33 3 26.2843 3 18C3 9.71573 9.71573 3 18 3C26.2843 3 33 9.71573 33 18ZM19.1551 19.2727L22.5709 19.2727L20.8061 22.7783L19.0655 19.2727H16.4545L20.8303 28L25.1818 19.2727L22.6364 19.2727L16.8021 8L11 19.2727H14.4812L16.8343 14.7446L19.1551 19.2727Z"
                fill="white" />
            </svg>
          </a>
        </div>
      </div>
    </div>
  }
  <hr />
  <div class="privacy">
    <a aria-label="Navigate to terms" [routerLink]="['/terms']">{{
      'menu.footer.terms' | translate
    }}</a>
    <a aria-label="Navigate to privacy" [routerLink]="['/privacy']">{{
      'menu.footer.privacy' | translate
    }}</a>
    <a aria-label="Navigate to cookies" [routerLink]="['/cookies']">{{
      'menu.footer.cookies' | translate
    }}</a>
    <p>Copyright 2022, Kinomap.com</p>
  </div>
</div>
